import React, { ReactNode, memo } from 'react';
import './FormLayout.scss';

interface FormLayoutProps {
  children: ReactNode;
}

const FormLayout: React.FC<FormLayoutProps> = memo(({ children }) => {
  return (
    <div className="layout-main-container">
      <div className="flex-container spacer-row top-spacer">
        <div className="wall-border"></div>
        <div className="wall-border"></div>
        <div className="wall-border"></div>
        <div className="wall-border"></div>
      </div>

      <div className="flex-container">
        <div className="wall-border"></div>
        <div className="form-page">
          <div className="container">{children}</div>
        </div>
        <div className="wall-border"></div>
      </div>

      <div className="flex-container spacer-row">
        <div className="wall-border"></div>
        <div className="wall-border"></div>
        <div className="wall-border"></div>
        <div className="wall-border"></div>
      </div>
    </div>
  );
});

export default FormLayout;
